module.exports = __webpack_public_path__ + "media/images/logos/saml2-5b7847df12af9b447bc56ec3b061d365.svg";